<!--
<template>
  <router-view />
</template>

<script lang="ts" setup>
  //
</script>
-->

<template>
  <div id="app">
    <!-- <notifications classes="my-notification" position="bottom float-right" group="notify" /> -->
    <!-- <notification ref="notification" /> -->
    <notifications position="top right" style="top:12px;"/>
    <router-view></router-view>
  </div>
</template>


<!-- <script lang="ts"> -->
<script>
/* eslint-disable */
import AppSettings from "./views/AppSettings.vue";
import { version } from "../package.json";
import * as Sentry from "@sentry/vue";
import config from 'devextreme/core/config'; 
import { licenseKey } from './devextreme-license'; 



export default {
  name: "App",
  components: {
    AppSettings
  },
  data: () => ({
    appVersion: version,
  }),
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      // refreshPage.methods.startInterval("version.json");
      config({licenseKey});
      if (!localStorage.getItem("DateFormat"))
        localStorage.setItem("DateFormat", "MM/DD/YYYY");

      let sentrytag = localStorage.getItem("sentrytag");
      if (sentrytag) {
        Sentry.configureScope((scope) => {
          scope.setTag("tenant", sentrytag);
        });
      }
      Sentry.configureScope((scope) => {
        let version = this.$store.getters.appVersion;
        scope.setTag("version", this.appVersion);
      });
      let userData = JSON.parse(localStorage.getItem("userData"));
      if (userData)
        Sentry.configureScope((scope) => {
          scope.setTag("LoggedInUser", userData.userEmail);
        });
    },
  },
  beforeCreate() {
    this.$store.commit("initialiseStore");
  },
};

</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Roboto");

body {
  background: #fff;
  font-family: "Roboto", sans-serif;
}

#app {
  background: #fff;
}

.v-toolbar {
  box-shadow: none !important;
}

.page {
  position: fixed;
  width: inherit;
}

@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";

.router-anim-enter-active {
  animation: coming 1s;
  animation-delay: 0.5s;
  opacity: 0;
}

.router-anim-leave-active {
  animation: going 1s;
}

@keyframes going {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50px);
    opacity: 0;
  }
}

@keyframes coming {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.my-notification {
  margin-bottom: 40px;
  margin-right: 5px;
  color: white;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.my-notification .notification-title {
  font-size: 18px;
  padding: 5px;
}

.my-notification .notification-content {
  font-size: 15px;
  padding: 5px;
}

.count_box {
  border-radius: 5px;
  padding: 2px;
  color: white;
  display: table-caption;
  min-width: 90px;
  min-height: 28px;
  text-align: center;
}

.orange {
  background: orange;
}

.grey {
  background: grey;
}

.red {
  background: red;
}

.green {
  background: green;
}

.purple {
  background: purple;
}

.blue {
  background: blue;
}

.heading {
  font-size: medium;
}

.align_left {
  text-align: left !important;
}

.padding_left5 {
  padding-left: 5px;
}

.width_max {
  width: max-content;
}
.bg-blur{
  backdrop-filter: blur(6px);
}
.fix-header{
  width:85%; position:sticky; top:10%; z-index:999
}
.font-23 {
  font-size: 23px;
    padding-left: 6px;
}

/* Ensure table layout is set properly */
.dx-datagrid-rowsview table {
  border-collapse: collapse;
}

/* Add vertical lines between all columns */
.dx-datagrid-rowsview .dx-row>td {
  border-right: 1px solid #ccc !important;
}

/* Remove border from last column to prevent double lines */
.dx-datagrid-rowsview .dx-row>td:last-child {
  border-right: none !important;
}

.dx-datagrid .dx-header-row .dx-datagrid-text-content {
  white-space: normal !important;
  word-wrap: break-word;
  overflow-wrap: break-word;
  line-height: 1.2;
  text-align: center;
  /* Optional: To center the text */
}

</style>